class PlpPage {
  constructor() {
    this.init();
  }

  addToCartClick = () => {
    let atcButton = document.querySelectorAll(".add-to-cart-btn");
    if(atcButton) {
      atcButton.forEach((item) => {
        item.addEventListener("click", function (event) {
          if(event.target.classList.contains("sold-out-button-wrapper")) {
            return false;
          }
          event.target.innerText = "Adding...";
          let vid = event.target.getAttribute("data-vid");
          if(vid) {
            let formData = {
              'items': [{
              'id': vid,
              'quantity': 1
              }]
            };
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(response => {
              return response.json();
            })
            .then(response => {
              setTimeout(() =>{
                event.target.innerText = "Add To Cart";
              },1000);
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          }
        });
      });      
    }
  }

  init = () => {
    window.addToCartClick = this.addToCartClick;
    window.addToCartClick();
  }
}

new PlpPage;